import { useMutation } from "@tanstack/react-query";

import { httpClient } from "@/lib/http";
import { HttpResponse, SignInRequest, SignInResponse } from "@/types";

export const useSignIn = () => {
  return useMutation({
    mutationFn: async (signInRequest: SignInRequest) => {
      const res = await httpClient.post<
        SignInResponse,
        HttpResponse<SignInResponse>,
        SignInRequest
      >("auth/login", signInRequest);

      return res.data;
    },
  });
};
